import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleBlue = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 76,
	height: 76,
	viewBox: "0 0 76 76",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38Z",
			fill: "#CEE6FF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 38,
			cy: 38,
			r: 32,
			fill: "#2171C6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.75 37.0045V38.4995C54.748 42.0037 53.6133 45.4134 51.5152 48.22C49.417 51.0266 46.4678 53.0798 43.1075 54.0734C39.7471 55.0669 36.1555 54.9476 32.8685 53.7332C29.5815 52.5188 26.7751 50.2744 24.8678 47.3348C22.9606 44.3951 22.0547 40.9176 22.2852 37.421C22.5158 33.9245 23.8705 30.5961 26.1472 27.9323C28.4239 25.2685 31.5008 23.412 34.9188 22.6398C38.3368 21.8675 41.9129 22.2208 45.1138 23.647",
			stroke: "white",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.75 25.5L38.5 41.7663L33.625 36.8913",
			stroke: "white",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCheckCircleBlue;
